module.exports = __webpack_public_path__ + "static/media/IconSearch.0749a616.svg";